/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  AvailableLanguagesField,
  AvailableSoftwaresField,
  MailAddressField,
  NameField,
  PortfolioField,
  QuestionField,
  ReasonField,
  ResumeField,
  SelfPrField,
  SkillSheetField,
  SocialNetworkUrlsField,
  TelField,
} from '~/form/components/organisms'
import validationRulesComposer from '~/form/libs/validationRulesComposer'
import type { Config } from '~/form/types'

const configs: Config[] = [
  {
    name: '氏名',
    component: NameField,
    props: {
      required: true,
    },
  },
  {
    name: 'メールアドレス',
    component: MailAddressField,
    props: {
      required: true,
    },
  },
  {
    name: '電話番号',
    component: TelField,
    props: {},
  },
  {
    name: 'あなたのことがわかるURL',
    component: SocialNetworkUrlsField,
    props: {},
  },
  {
    name: '自己PR',
    component: SelfPrField,
    props: {},
  },
  {
    name: '履歴書',
    component: ResumeField,
    props: {
      required: true,
    },
  },
  {
    name: 'スキルシート',
    component: SkillSheetField,
    props: {},
  },
  {
    name: '使用可能ソフトウェア',
    component: AvailableSoftwaresField,
    props: {
      placeholder:
        'Word、Excel、Power Point、Photoshop、Illustrator、 Premiere、Google Analyticsなど',
    },
  },
  {
    name: '応募理由',
    component: ReasonField,
    props: {
      required: true,
    },
  },
  {
    name: '質問事項',
    component: QuestionField,
    props: {},
  },
]

export default configs

export const validators = validationRulesComposer(configs)
